import { Link } from "react-router-dom";

export default function Logo() {
    const theme = window.AppSettings?.theme;
    // Prefer textPath if available, otherwise fallback to path
    const logoPath = theme?.logo?.textPath || theme?.logo?.path;
    const height = theme?.logo?.height || 32;

    if (logoPath) {
        return (
            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={logoPath}
                    alt="Logo"
                    style={{ height: height, display: 'block' }}
                />
            </Link>
        )
    }

    return (
        <Link
            to="/"
            style={{
                color: '#ffffff',
                fontWeight: 'bold',
                fontSize: '18px',
                userSelect: 'none',
                textDecoration: 'none'
            }}
        >
            HIS {' © '} {new Date().getFullYear()}
        </Link>
    )
}
